export default "__VITE_ASSET__CzH_rlUF__"